/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StorageFile } from './storageFile';


export interface BusinessObjectDataStorageFilesCreateResponse { 
    /**
     * The namespace of the business object data
     */
    namespace: string;
    /**
     * The definition name of the business object data
     */
    businessObjectDefinitionName: string;
    /**
     * The format usage of the business object data
     */
    businessObjectFormatUsage: string;
    /**
     * The format file type of the business object data
     */
    businessObjectFormatFileType: string;
    /**
     * The format version of the business object data
     */
    businessObjectFormatVersion?: number;
    /**
     * The the primary partition value of the business object data
     */
    partitionValue: string;
    /**
     * The subpartition values of the business object data
     */
    subPartitionValues?: Array<string>;
    /**
     * The version of the business object data
     */
    businessObjectDataVersion?: number;
    /**
     * The name of the storage                
     */
    storageName: string;
    /**
     * The list of storage files
     */
    storageFiles?: Array<StorageFile>;
}
